// window.location 对象
// <a>.href 对象
// url 字符串转 <a>.href

var hash_util = require('./hash_util');
var search_util = require('./search_util');
function _Url (o) {
	// this.host = o.host? o.host: window.location.host;
	// this.hostname = o.hostname? o.hostname: window.location.hostname;
	// this.pathname = o.pathname? o.pathname: window.location.pathname;
	this.host = o.host;
	this.hostname = o.hostname;
	this.origin = o.origin;
	this.pathname = o.pathname;
	this.port = o.port;
	this.protocol = o.protocol;

	// 如果对象的某个属性是对象，建议保存该属性对象状态
	// 使用属性对象的克隆对象作为属性
	this._search = search_util.initBySearchString(o.search? o.search: '?');
	this._hash = hash_util.initByHashString(o.hash? o.hash: '#');

	this.deepReset();
}

_Url.prototype.getSearch = function() {
	return this.search.toString();
};

_Url.prototype.getHash = function() {
	return this.hash.toString();
};

_Url.prototype.s = _Url.prototype.setSearch = function(k, v) {
	this.search.set(k, v);
	return this;
};

_Url.prototype.h = _Url.prototype.setHash = function(k, v) {
	this.hash.set(k, v);
	return this;
};

_Url.prototype.resetSearch = function() {
	this.search.reset();
	return this;
};

_Url.prototype.resetHash = function() {
	this.hash.reset();
	return this;
};

_Url.prototype.reset = function() {
	this.resetSearch();
	this.resetHash();
	return this;
};

_Url.prototype.deepReset = function() {
	this.search = $.extend({}, this._search);
	this.hash = $.extend({}, this._hash);
	return this.reset();
};

_Url.prototype.toString = function(bool) {
	if (this.host) {
		return this.protocol + '//' + this.host + this.pathname + this.getSearch() + this.getHash();
	} else {
		return this.pathname + this.getSearch() + this.getHash();
	}
};

_Url.prototype.go = function() {
	window.location.href = this.toString();
};

module.exports = {
	initByUrlString: function (s) {
		var $a = $('<a>').attr('href', s);
		return this.initByUrlObject($a[0]);
	},
	initByUrlObject: function (o) {
		return new _Url(o);
	},
	// 
	_location: {},
	// 创建一个 url 对象，与 location 完全独立
	// 使用本方法跳转 hash，其他模块将不能获取到最新状态
	initByLocation: function () {
		return $.extend({}, this._location).deepReset();
	},
	// 通过此方法，获取 url 的实时状态，建议不要直接操作本对象的 set 方法
	// 通过本方法修改 url 状态而不跳转，其他模块跳转时可能会遇到奇怪的值
	getLocation: function () {
		return this._location;
	},
	goByHash: function (k, v) {
		this._location.h(k, v).go();
		return this;
	}
};

module.exports._location = module.exports.initByUrlObject(window.location);


//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/url_util/url_util.js
// module id = 5
// module chunks = 4